<template>

  <v-select 
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
export default {
  name: 'SelectCompany',
  props: [
    'value',
    'placeholder'
  ],
  data () {
    return {
      'companies': []
    }
  },
  computed: {
    valueId () {
      return this.value && this.value._id ? this.value._id : this.value
    },
    options () {
      return this.companies.map((val) => {
        return {
          label: val.name,
          value: val._id,
          object: val
        }
      })
    },
    selected () {
      return this.options.find((val) => {
        return val.value === this.valueId
      })
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getCompanies', {sort: 'name', limit: 2000})
      .then((result) => {
        this.companies = result.docs
      })
    },
    change (val) {
      const value = val ? val.value : null
      const valueObject = val ? val.object : null

      if (value !== this.valueId) {
        this.$emit('input', value)
        this.$emit('inputObject', valueObject)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectCompany.vue